export default __webpack_public_path__ + "static/media/icon-any-file.fc9b91ba.svg";